export const createMatrix = (rows: number, cols: number) =>
  Array.from({ length: rows }, (_, rowIndex) =>
    Array.from({ length: cols }, (_c, colIndex) => rowIndex * cols + colIndex),
  )
